import 'utils/publicPath'
import smoothscroll from 'smoothscroll-polyfill'

import configureCustomizerApp from 'customizer/configureCustomizerApp'

import themeConfig from './config.json'
import Customizer from './customizer'

smoothscroll.polyfill()

configureCustomizerApp(Customizer, themeConfig)
